/**
 * The company page's warning after a creation whose logo could not be saved
 * (issue #20, H11). The company exists, so the creation form moves on to its
 * page; this is how it tells that page, which is another route, to open with
 * the message. In memory only: it survives the navigation, not a reload — the
 * warning is only worth showing once.
 */
export const LOGO_WARNING_MESSAGE =
  "Le logo n'a pas pu être enregistré. Ajoutez-le depuis les Paramètres.";

const pending = new Set<string>();

export function flagLogoWarning(companyId: string): void {
  pending.add(companyId);
}

export function hasLogoWarning(companyId: string): boolean {
  return pending.has(companyId);
}

export function clearLogoWarning(companyId: string): void {
  pending.delete(companyId);
}
